import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BriefingSubTypeModel } from 'src/Models/BriefingMasterModel';
import { I360Service } from 'src/Services/i360Service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-briefing-sub-type',
  templateUrl: './briefing-sub-type.component.html',
  styleUrls: ['./briefing-sub-type.component.css']
})
export class BriefingSubTypeComponent implements OnInit {

  tokenKey: string;
  isloading: boolean = false;
  PageNumber: number = 1;
  listofSubTypes: BriefingSubTypeModel[];
  listofSubTypesExport: BriefingSubTypeModel[];
  SelectedTool: string;
  PageSize: number;
  isRecord: boolean = false;
  totalRecordCount: number = 0;
  FilterText: string;
  OrderBy: string;
  WhereCondition: string;
  isAscending: boolean = false;
  upDowcarrierCatNameCSS: string = '';
  upDowSortOrderCSS: string = '';
  upDowShortNameCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowIsArchiveCSS: string = '';
  BulletinSubTypeId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly i360service: I360Service,
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'SortOrder';
    this.FilterText = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Briefing Sub Type');
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.isloading = true;
    this.GetAllSubTypes();
  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.FilterText = $event.target.value;
    else
      this.FilterText = 'null';

    this.GetAllSubTypes();
  }

  GetAllSubTypes() {
    this.isloading = true;
    this.listofSubTypes=[];
    if (this.FilterText == "null") this.FilterText = " ";
    this.i360service.i360BulletinSubType(this.tokenKey, this.PageNumber, this.PageSize, this.FilterText, this.OrderBy,false).subscribe(
      data => {
        this.isloading = false;
        this.listofSubTypes = data['listOfBulletinSubType'];
        if (this.listofSubTypes != null) {
          if (this.listofSubTypes.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofSubTypes[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  addBriefSubType() {
    let navigation = '/admin/' + this.SelectedTool + '/briefingSubType/manage';
    this.router.navigate([navigation]);
  }

  updateBriefSubType(BulletinSubTypeId) {
    let navigation = '/admin/' + this.SelectedTool + '/briefingSubType/manage/' + BulletinSubTypeId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.BulletinSubTypeId = id;
  }

  deleteBrifSubType(BulletinSubTypeId) {
    this.isloading = true;
    this.i360service.DeleteBriefingSubType(this.tokenKey, BulletinSubTypeId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else
            this.showMessage("Deleted successfully", 'Success', 'success')
        }
        this.GetAllSubTypes();
      },
      error => { }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetAllSubTypes();
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "BulletinSubType") {
        this.upDowcarrierCatNameCSS = 'fa fa-arrow-down';
        this.upDowShortNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "ShortName") {
        this.upDowcarrierCatNameCSS = '';
        this.upDowShortNameCSS = 'fa fa-arrow-down';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "SortOrder") {
        this.upDowcarrierCatNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortOrderCSS = 'fa fa-arrow-down';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowcarrierCatNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "IsArchive") {
        this.upDowcarrierCatNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "BulletinSubType") {
        this.upDowcarrierCatNameCSS = 'fa fa-arrow-up';
        this.upDowShortNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "ShortName") {
        this.upDowcarrierCatNameCSS = '';
        this.upDowShortNameCSS = 'fa fa-arrow-up';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "SortOrder") {
        this.upDowcarrierCatNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortOrderCSS = 'fa fa-arrow-up';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowcarrierCatNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "IsArchive") {
        this.upDowcarrierCatNameCSS = '';
        this.upDowShortNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetAllSubTypes();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportBriefingSubType() {
    this.isloading = true;
    this.listofSubTypesExport = [];
    if (this.FilterText == "null") this.FilterText = " ";
    this.i360service.i360BulletinSubType(this.tokenKey, this.PageNumber, this.PageSize, this.FilterText, this.OrderBy,true).subscribe(
      data => {
        this.listofSubTypesExport = data['listOfBulletinSubType'];
        if (this.listofSubTypesExport != null) {
          if (this.listofSubTypesExport.length > 0) {
            setTimeout(() => {
              this.DownloadBriefingSubType();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadBriefingSubType() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportBriefingsBriefingSubType';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportBriefingsBriefingSubType.xls");
  }
}
